export default "__VITE_ASSET__7755c062__"